<template>
    <div class="data-container">
        <Head />
        <div class="data-banner">
            <div class="title animated fadeIn">
                <h1>{{$t('data.col1.i1')}}<br>{{$t('data.col1.i2')}}</h1>
                <h5>{{$t('data.col1.i3')}}</h5>
            </div>
            <div class="data-info">
                <img class="cardbg" src="../../assets/data/datacenter_cardbg.png" alt="">
                <div class="title">
                    <h1 ref="animate1" :class="{'animated fadeIn': animate1}">{{$t('data.col2.i1')}}<br>{{$t('data.col2.i2')}}</h1>
                    <p :class="{'animated fadeIn': animate1}" class="node-anchor">{{$t('data.col2.i3')}}</p>
                </div>
                <div class="list">
                    <div class="info" :class="{'animated fadeInLeft delay-1s': animate1}">
                        <div class="list-icon">
                            <img src="../../assets/data/datacenter_core_icon1.png" alt="">
                        </div>
                        <div class="list-text">
                            <h1>{{$t('data.col2.i4')}}</h1>
                            <p>{{$t('data.col2.i5')}}</p>
                        </div>
                    </div>
                    <div class="info" :class="{'animated fadeInRight delay-1s': animate1}">
                        <div class="list-icon">
                            <img src="../../assets/data/datacenter_core_icon2.png" alt="">
                        </div>
                        <div class="list-text" >
                            <h1>{{$t('data.col2.i6')}}</h1>
                            <p>{{$t('data.col2.i7')}}</p>
                        </div>
                    </div>
                    <div class="info" :class="{'animated fadeInLeft delay-1s': animate1}">
                        <div class="list-icon">
                            <img src="../../assets/data/datacenter_core_icon3.png" alt="">
                        </div>
                        <div class="list-text">
                            <h1>{{$t('data.col2.i8')}}</h1>
                            <p>{{$t('data.col2.i9')}}</p>
                        </div>
                    </div>
                    <div class="info" :class="{'animated fadeInRight delay-1s': animate1}">
                        <div class="list-icon">
                            <img src="../../assets/data/datacenter_core_icon4.png" alt="">
                        </div>
                        <div class="list-text">
                            <h1>{{$t('data.col2.i10')}}</h1>
                            <p>{{$t('data.col2.i11')}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="data-content ">
            <div class="infrastructure">
                <div class="title" ref="animate2" :class="{'animated fadeIn': animate2}">
                    <h1>{{$t('data.col3.i1')}}</h1>
                    <p>{{$t('data.col3.i2')}}</p>
                </div>
                <div class="content" ref="animate3">
                    <div class="left" :class="{'animated fadeInLeft': animate3}">
                        <p>{{$t('data.col3.i3')}}</p>
                        <p>{{$t('data.col3.i4')}}</p>
                        <p>{{$t('data.col3.i5')}}</p>
                    </div>
                    <div class="right" :class="{'animated fadeInRight': animate3}">
                        <img src="../../assets/data/datacenter_pic1.jpg" alt="">
                    </div>
                </div>
            </div>
            <div class="Service">
                <div class="info" ref="animate4" :class="{'animated fadeIn': animate4}">
                    <div class="title">
                        <h1>{{$t('data.col4.i1')}}</h1>
                        <p>{{$t('data.col4.i2')}}</p>
                    </div>
                    <div class="list">
                        <ul class="list-info">
                            <li>
                                <div class="top step" :class="{'animated fadeIn delay-1s': animate4}">
                                    <p>{{$t('data.col4.i3')}}</p>
                                </div>
                                <p class="line"></p>
                                <div class="bottom step" :class="{'animated fadeIn delay-1s': animate4}">
                                    <p>{{$t('data.col4.i4')}}</p>
                                </div>
                            </li>
                            <li>
                                <div class="top step" :class="{'animated fadeIn delay-1s': animate4}">
                                    <p>{{$t('data.col4.i5')}}</p>
                                </div>
                                <p class="line"></p>
                                <div class="bottom step" :class="{'animated fadeIn delay-1s': animate4}">
                                    <p>{{$t('data.col4.i6')}}</p>
                                </div>
                            </li>
                            <li>
                                <div class="top step" :class="{'animated fadeIn delay-1s': animate4}">
                                    <p>{{$t('data.col4.i7')}}</p>
                                </div>
                                <p class="line"></p>
                                <div class="bottom step" :class="{'animated fadeIn delay-1s': animate4}">
                                    <p>{{$t('data.col4.i8')}}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="lifecycle">
                <h1 class="title" ref="animate5" :class="{'animated fadeIn': animate5}">{{$t('data.col5.i1')}}</h1>
                <div class="lifecycle-box" :class="{'animated fadeIn delay-1s': animate5}">
                    <div class="step step1">
                        <div class="button">
                            <img src="../../assets/data/datacenter_icon1.png" class="icon" alt="">
                            <span>{{$t('data.col5.i2')}}</span>
                        </div>
                        <p class="text">{{$t('data.col5.i3')}}<br>{{$t('data.col5.i4')}}</p>
                    </div>
                    <div class="step step2">
                        <div class="button">
                            <img src="../../assets/data/datacenter_icon2.png" class="icon" alt="">
                            <span>{{$t('data.col5.i5')}}</span>
                        </div>
                        <p class="text">{{$t('data.col5.i6')}}<br>{{$t('data.col5.i7')}}</p>
                    </div>
                    <div class="step step3">
                        <div class="button">
                            <img src="../../assets/data/datacenter_icon3.png" class="icon" alt="">
                            <span>{{$t('data.col5.i8')}}</span>
                        </div>
                        <p class="text">{{$t('data.col5.i9')}}<br>{{$t('data.col5.i10')}}</p>
                    </div>
                    <div class="step step4">
                        <div class="button">
                            <img src="../../assets/data/datacenter_icon4.png" class="icon" alt="">
                            <span>{{$t('data.col5.i11')}}</span>
                        </div>
                        <p class="text">{{$t('data.col5.i12')}}<br>{{$t('data.col5.i13')}}</p>
                    </div>
                    <div class="step step5">
                        <div class="button">
                            <img src="../../assets/data/datacenter_icon5.png" class="icon" alt="">
                            <span>{{$t('data.col5.i14')}}</span>
                        </div>
                        <p class="text">{{$t('data.col5.i15')}}<br>{{$t('data.col5.i16')}}<br>{{$t('data.col5.i17')}}<br>{{$t('data.col5.i18')}}</p>
                        
                    </div>
                    <div class="step step6">
                        <div class="button">
                            <img src="../../assets/data/datacenter_icon6.png" class="icon" alt="">
                            <span>{{$t('data.col5.i19')}}</span>
                        </div>
                        <p class="text">{{$t('data.col5.i20')}}<br>{{$t('data.col5.i21')}}</p>
                    </div>
                </div>
            </div>
            <div class="weidong">
                <div class="content">
                    <h1 class="title" ref="animate6" :class="{'animated fadeIn': animate6}">{{$t('data.col6.i1')}}</h1>
                    <div class="box" :class="{'animated fadeIn delay-1s': animate6}">
                        <div class="step1 step-top">
                            <img src="../../assets/data/datacener_pic_qd.jpg" class="img" alt="">
                        </div>
                        <div class="step2 step-top">
                            <div class="info">
                                <h2>{{$t('data.col6.i2')}}</h2>
                                <p>
                                    {{$t('data.col6.i3')}}<br>
                                    {{$t('data.col6.i4')}}<br>
                                    {{$t('data.col6.i5')}}
                                </p>
                            </div>
                        </div>
                        <div class="step3 step-top">
                            <img src="../../assets/data/datacener_pic_erdos.jpg" class="img" alt="">
                        </div>
                        <div class="step4 step-top">
                            <div class="info">
                                <h2>{{$t('data.col6.i6')}}</h2>
                                <p>
                                    {{$t('data.col6.i7')}}<br>
                                    {{$t('data.col6.i8')}}<br>
                                    {{$t('data.col6.i9')}}<br>
                                    {{$t('data.col6.i10')}}
                                </p>
                            </div>
                        </div>
                        <div class="step5 step-bottom">
                            <div class="info">
                                <h2>{{$t('data.col6.i11')}}</h2>
                                <p>
                                    {{$t('data.col6.i12')}}<br>
                                    {{$t('data.col6.i13')}}<br>
                                    {{$t('data.col6.i14')}}
                                </p>
                            </div>
                        </div>
                        <div class="step6 step-bottom">
                            <img src="../../assets/data/datacener_pic_bj.jpg" class="img" alt="">
                        </div>
                        <div class="step7 step-bottom">
                            <div class="info">
                                <h2>{{$t('data.col6.i15')}}</h2>
                                <p>
                                    {{$t('data.col6.i16')}}<br>
                                    {{$t('data.col6.i17')}}<br>
                                    {{$t('data.col6.i18')}}
                                </p>
                            </div>
                        </div>
                        <div class="step8 step-bottom">
                            <img src="../../assets/data/datacener_pic_gy.jpg" class="img" alt="">
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <Footer />
    </div>
</template>
<script>
import Head from '../../components/head';
import Footer from '../../components/footer';
import scroll from '../mixin/scroll';
export default {
    components: {
        Head,
        Footer
    },
    mixins: [scroll],
    data() {
        return {
            refArray: [
                {ref: 'animate1', show: 'animate1', offset: 10,},
                {ref: 'animate2', show: 'animate2',},
                {ref: 'animate3', show: 'animate3',},
                {ref: 'animate4', show: 'animate4',},
                {ref: 'animate5', show: 'animate5',},
                {ref: 'animate6', show: 'animate6',},
                {ref: 'animate7', show: 'animate7',},
                {ref: 'animate8', show: 'animate8',},
                {ref: 'animate9', show: 'animate9',},
            ],
            animate1: false,
            animate2: false,
            animate3: false,
            animate4: false,
            animate5: false,
            animate6: false,
            animate7: false,
            animate8: false,
            animate9: false,
        }  
    },
     mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
}
</script>
<style lang="less" scoped>
    .data-container {
        .data-banner {
            width: 100%;
            height: 700px;
            background: url('../../assets/data/datacenter_bg.jpg') no-repeat;
            background-size: cover;
            background-position:center;
            box-sizing: border-box;
            padding-top: 217px;
            .title {
                width: 1200px;
                margin: 0 auto;
                text-align: center;
                color: #FFFFFF;
                h1 {
                    font-size: 60px;
                    line-height: 72px;
                    font-family: HelveticaNeue-Bold ,HelveticaNeue, Arial, sans-serif;
                }
                h5 {
                    width: 942px;
                    margin: 0 auto;
                    margin-top: 30px;
                    font-size: 24px;
                    line-height: 34px;
                    font-family: HelveticaNeue, Arial, sans-serif;
                }
            }
        }
        .data-info {
            width: 1200px;
            overflow: hidden;
            height: 702px;
            margin: 0 auto;
            margin-top: 120px;
            box-sizing: border-box;
            background: #fff;
            box-shadow: 0 4px 20px 0 rgba(0,0,0,0.15);
            position: relative;
            padding: 60px 50px 0;
            
            .cardbg {
                width: 309px;
                position: absolute;
                top: 0;
                right: 0;
            }
            .title {
                text-align: left;
                width: 100%;
                h1 {
                    font-size: 48px;
                    color: #000000;
                    letter-spacing: 0;
                    line-height: 55px;
                    font-family: HelveticaNeue-Bold ,HelveticaNeue, Arial, sans-serif;
                }
                p {
                    width: 100%;
                    margin-top: 30px;
                    font-size: 16px;
                    color: #000000;
                    letter-spacing: 0.17px;
                    line-height: 24px;
                    font-family: HelveticaNeue, Arial, sans-serif;
                }
            }
            .list {
                margin-top: 58px;
                .info {
                    display: inline-block;
                    margin-bottom: 50px;
                    &:nth-child(2n){
                        margin-left: 50px;
                    }
                    .list-icon {
                        display: inline-block;
                        margin-right: 25px;
                        vertical-align: middle;
                        img {
                            width: 100px;
                        }
                    }
                    .list-text {
                        width: 400px;
                        vertical-align: middle;
                        display: inline-block;
                        h1 {
                            font-size: 24px;
                            color: #000000;
                            letter-spacing: 0.1px;
                            line-height: 24px;
                            font-family: HelveticaNeue-Bold ,HelveticaNeue, Arial, sans-serif;
                        }
                        p {
                            margin-top: 10px;
                            font-size: 14px;
                            color: #666666;
                            letter-spacing: 0.06px;
                            line-height: 20px;
                            font-family: HelveticaNeue, Arial, sans-serif;
                        }
                    }
                }
            }
        }
        .data-content {
            margin-top: 663px;
            .infrastructure {
                width: 1200px;
                overflow: hidden;
                margin: 0 auto;
                .title {
                    h1 {
                        font-size: 48px;
                        color: #000000;
                        line-height: 55px;
                        font-family: HelveticaNeue-Bold ,HelveticaNeue, Arial, sans-serif;
                    }
                    p {
                        margin-top: 15px;
                        font-size: 24px;
                        color: #000000;
                        letter-spacing: 0.1px;
                        line-height: 40px;
                        font-family: HelveticaNeue, Arial, sans-serif;
                    }
                }
                .content {
                    overflow: hidden;
                    margin-top: 51px;
                    margin-bottom: 100px;
                    .left {
                        float: left;
                        width: 520px;
                        font-size: 16px;
                        color: #000000;
                        letter-spacing: 0.07px;
                        line-height: 28px;
                        p {
                            margin-bottom: 20px;
                            &:last-child{
                                margin-bottom: 0;
                            }
                        }
                    }
                    .right {
                        float: right;
                        img {
                            width: 600px;
                        }
                    }
                }
            }
            .Service {
                width: 100%;
                height: 851px;
                margin: 0 auto;
                background: url('../../assets/data/datacenter_bg_full.png') no-repeat;
                background-size: cover;
                background-position: center;
                box-sizing: border-box;
                padding-top: 80px;
                .info {
                    width: 1200px;
                    margin: 0 auto;
                    .title {
                         color: #FFFFFF;
                         margin-bottom: 60px;
                        h1 {
                            font-size: 48px;
                            letter-spacing: 0.1px;
                            line-height: 55px;
                            margin-bottom: 30px;
                            font-family: HelveticaNeue-Bold ,HelveticaNeue, Arial, sans-serif;
                        }
                        p {
                            font-size: 24px;
                            line-height: 40px;
                        }
                    }
                }
                .list {
                    margin-top: 50px;
                    .list-info {
                        width: 1200px;
                        margin: 0 auto;
                        // overflow: hidden;
                        li {
                            float: left;
                            color: #FFFFFF;
                            
                            .step {
                                width: 400px;
                                height: 168px;
                                background: #2244AB;
                                box-sizing: border-box;
                                padding: 10px 30px 0px;
                                line-height: 148px;
                                overflow: hidden;
                                position: relative;
                                p {
                                    display: inline-block;
                                    vertical-align: middle;
                                    font-size: 16px;
                                    line-height: 24px;
                                }
                            }
                            .line {
                                width: 100%;
                                height: 10px;
                                background: #2F7FFF;
                                opacity: .3;
                            }
                            &:nth-child(1) {
                                .top{
                                    &::after {
                                        content: '';
                                        position: absolute;
                                        width: 38px;
                                        height: 38px;
                                        background: #2870FF;
                                        top: -15px;
                                        left:-15px;
                                        border-radius: 50%;
                                    }
                                }  
                                .bottom {
                                    background: #325AD1;
                                    &::after {
                                        content: '';
                                        position: absolute;
                                        width: 38px;
                                        height: 38px;
                                        background:#4E85FF ;
                                        left: -15px;
                                        bottom:-15px;
                                        border-radius: 50%;
                                    }
                                } 
                            }
                            &:nth-child(2) {
                                position: relative;
                                bottom: 20px;
                                .top{
                                    background: #F68F30;
                                    &::before {
                                        content: '';
                                        position: absolute;
                                        top: -38px;
                                        left: 162px;
                                        width: 76px;
                                        height: 76px;
                                        background: #F5B04A;
                                        border-radius: 50%;
                                    }
                                }  
                                .bottom {
                                    background: #FF891A;
                                    &::before {
                                        content: '';
                                        position: absolute;
                                        bottom: -38px;
                                        left: 162px;
                                        width: 76px;
                                        height: 76px;
                                        background: #FFA83D;
                                        border-radius: 50%;
                                    }
                                } 
                                .line {
                                    background: #FFAD4E;
                                }
                            }
                            &:nth-child(3) {
                                .top{
                                    &::after {
                                        content: '';
                                        position: absolute;
                                        width: 38px;
                                        height: 38px;
                                        background: #2870FF;
                                        top: -15px;
                                        right:-15px;
                                        border-radius: 50%;
                                    }
                                }  
                                .bottom {
                                    background: #325AD1;
                                    &::after {
                                        content: '';
                                        position: absolute;
                                        width: 38px;
                                        height: 38px;
                                        background:#4E85FF ;
                                        right: -15px;
                                        bottom:-15px;
                                        border-radius: 50%;
                                    }
                                } 
                            }
                            
                        }
                    }
                }
            }
            .lifecycle {
                width: 1200px;
                margin: 90px auto 270px;
                .title {
                    font-size: 48px;
                    color: #000000;
                    line-height: 60px;
                    margin-bottom: 100px;
                    font-family: HelveticaNeue-Bold ,HelveticaNeue, Arial, sans-serif;
                }
                .lifecycle-box {
                    width: 100%;
                    height: 266px;
                    background: url('../../assets/data/datacenter_line.png') no-repeat;
                    background-size: cover;
                    background-position: center;
                    position: relative;
                    .step {
                        position: absolute;
                        top: -35px;
                        width: auto;
                        .button {
                            height: 70px;
                            border-radius: 35px;
                            line-height: 70px;
                            color: #fff;
                            font-size: 18px;
                            text-align: center;
                            margin-bottom: 22px;
                            img {
                                width: 30px;
                                vertical-align: middle;
                            }
                            span {
                                display: inline-block;
                                margin-left: 14px;
                                vertical-align: middle;
                                font-family: HelveticaNeue-Bold ,HelveticaNeue, Arial, sans-serif;
                            }
                        }
                        .text {
                            font-size: 16px;
                            color: #8573D2;
                            text-align: center;
                            line-height: 30px;
                            width: 243px;
                            font-family: PingFangTC-Semibold, HelveticaNeue, Arial, sans-serif;
                        }
                        &.step1 {
                            .button {
                                width: 250px;
                                background: #8573D2 ;
                            }
                            
                        }
                        &.step2 {
                            left: 386px;
                            .button {
                                width: 358px;
                                background: #495DFF ;
                            }
                            .text {
                                width: 358px;
                                color: #495DFF;
                            }
                            
                        }
                        &.step3 {
                            right: 90px;
                            .button {
                                width: 280px;
                                background: #498EFF ;
                            }
                            .text {
                                width: 280px;
                                color: #498EFF;
                            }
                            
                        }
                        &.step4 {
                            top: 225px;
                            .button {
                                width: 277px;
                                background: #C1D387 ;
                            }
                            .text {
                                width: 277px;
                                color: #C1D387;
                            }
                        }
                        &.step5 {
                            top: 225px;
                            left: 457px;
                            .button {
                                width: 186px;
                                background: #88C296 ;
                            }
                            .text {
                                width: 196px;
                                color: #88C296;
                            }
                        }
                        &.step6 {
                            top: 225px;
                            right: 143px;
                            .button {
                                width: 227px;
                                background: #50A6AE ;
                            }
                            .text {
                                width: 227px;
                                color: #50A6AE;
                            }
                        }
                    }
                }

            }
            .weidong {
                width: 100%;
                height: 720px;
                background: url('../../assets/data/datacenter_bg_dcs.jpg') no-repeat;
                background-size: cover;
                background-position: center;
                box-sizing: border-box;
                padding-top: 77px;
                .content {
                    width: 1200px;
                    margin: 0 auto;
                    color: #FFFFFF;
                    .title {
                        font-size: 48px;
                        line-height: 60px;
                        margin-bottom: 80px;
                        font-family: HelveticaNeue-Bold ,HelveticaNeue, Arial, sans-serif;
                    }
                    .box {
                        .step-top,.step-bottom {
                            float: left;
                            width: 300px;
                            height: 200px;
                            background: rgba(0, 0, 0, .4);
                            line-height: 200px;
                            box-sizing: border-box;
                            padding-right: 40px;
                            img {
                                width: 300px;
                            }
                            .info {
                                display: inline-block;
                                vertical-align: middle;
                                width: 100%;
                                box-sizing: border-box;
                                text-align: right;
                                h2 {
                                    font-size: 24px;
                                    line-height: 24px;
                                    margin-bottom: 14px;
                                    position: relative;
                                    font-family: HelveticaNeue-Bold ,HelveticaNeue, Arial, sans-serif;
                                    
                                }
                                p{
                                    font-size: 14px;
                                    line-height: 24px;
                                }
                            }

                        }
                        .step-bottom {
                            .info h2 {
                                &::after{
                                    content: '';
                                    position: absolute;
                                    top: 7px;
                                    right: -20px;
                                    width: 0;
                                    height: 0;
                                    border-top: 5px solid transparent;
                                    border-left: 10px solid#FD8E0D;
                                    border-bottom: 5px solid transparent;
                                }
                            }
                        }
                        .step-top {
                            padding-right: 0;
                            .info {
                                text-align: left;
                                padding-right: 0;
                                padding-left: 40px;
                                h2 {
                                    &::after{
                                        content: '';
                                        position: absolute;
                                        top: 7px;
                                        left: -20px;
                                        width: 0;
                                        height: 0;
                                        border-top: 5px solid transparent;
                                        border-right: 10px solid #FD8E0D;
                                        border-bottom: 5px solid transparent;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
.lang-ru {
    .data-container .data-content{
        margin-top: 700px;
    }
    .Service {
        height: 851px;
    }
}
</style>